import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';
import { jsx as _jsx } from "react/jsx-runtime";
export const SplitButtonDivider = _ref => {
  let {
    disabled
  } = _ref;
  const theme = useInterstateTheme();
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      width: '1px',
      backgroundColor: disabled ? `${theme.tokens.ComponentSplitButtonDividerBorder} !important` : ''
    }
  });
};